import { IKnmErknmFormSuspensionEvent } from '../interfaces/IKnmErknmFormSuspensionEvent';

export const sortSuspensionEvents = (suspensionEvents: IKnmErknmFormSuspensionEvent[]) => {
  suspensionEvents.sort((a, b) => {
    return a.dateCreate && b.dateCreate ? new Date(a.dateCreate).valueOf() - new Date(b.dateCreate).valueOf() : 0;
  });
};
